// extracted by mini-css-extract-plugin
export default {"main":"full_main__Vz1vX","hide":"full_hide__dcqHS"};